import { Logger } from '~~/helpers/logger';
import { errorToString } from '~~/helpers/error/errorToString';
import type { Address, ApiParams } from '~~/types/commercetools';
import { useCart } from '~/utils/ct/composables/useCart';

export function useShipping() {

  const { cart, load: loadCart } = useCart();

  const loading = useState<boolean>('useShipping-loading', () => false);
  const shipping = useState<Address | null>('useShipping-shipping', () => null);
  const error = useState<{
    load: string | null,
  }>('useShipping-error', () => ({
    load: null,
  }));

  async function load({ customQuery }: ApiParams = {}) {

    Logger.debug('useShipping.load');
    try {

      loading.value = true;

      if (!cart.value?.shippingAddress) {

        await loadCart({ customQuery });
      
      }
      error.value.load = null;
      shipping.value = cart.value?.shippingAddress || null;
    
    } catch (err) {

      error.value.load = errorToString(err);
      Logger.error('useShipping/load', err);
    
    } finally {

      loading.value = false;
    
    }
  
  }

  return {
    shipping: computed(() => shipping.value),
    loading: computed(() => loading.value),
    error: computed(() => error.value),
    load,
  };

}
